/**
 * CalculatorButton Component
 * STANDALONE - Extracted from App.jsx line 383-389
 */

import './CalculatorButton.css'

function CalculatorButton({ onClick = () => {} }) {
  return (
    <button
      className="calculator-btn"
      onClick={onClick}
      title="Quick Calculator"
    >
      <i className="fas fa-calculator"></i>
    </button>
  )
}

export default CalculatorButton
